import { getEmployerProfileForWorker } from "@/queries/api/profileApi";
import { getBusinessReviews } from "@/queries/api/reviewApi";
import { QueryKeys } from "@/queries/queryKeys";

export function makeProfileQuery(employerId: string) {
  return {
    queryKey: [QueryKeys.BUSINESS_PROFILE, employerId],
    queryFn: () => getEmployerProfileForWorker(Number(employerId)),
  };
}

export function makeReviewQuery(employerId: string) {
  return {
    queryKey: [QueryKeys.BUSINESS_REVIEWS, employerId],
    queryFn: () => getBusinessReviews(Number(employerId)),
  };
}

